export default __webpack_public_path__ + "9a78a5cfbdff2564630cd2451cbe1c24.png";